// Imports
import { transparentize } from 'polished';
import { useTheme } from 'styled-components/macro';
import theme from '../../../../../../shareables/theme';
import { GeneratedThemeProps } from '../../../../../templates/template-style';


// A hook that creates a custom Stripe appearance object
const useStripeAppearance = () => {
	// Use styled components functionality
	const templateTheme = useTheme();
	
	
	// Type guard
	function isGeneratedTheme(templateTheme: unknown): templateTheme is GeneratedThemeProps {
		return templateTheme !== null && typeof templateTheme === 'object' && 'baseColor' in templateTheme;
	}
	
	if (!isGeneratedTheme(templateTheme)) {
		throw new Error('This should not be possible');
	}
	
	
	// Return custom Stripe appearance
	return {
		variables: {
			fontFamily: templateTheme.fontFamily,
			spacingUnit: '0.1875rem',
			spacingGridRow: '1.25rem',
			borderRadius: '0.25rem',
			colorPrimary: theme.colors.primary,
			colorDanger: theme.colors.danger,
			focusBoxShadow: `0 0 0 0.125em ${transparentize(0.75, theme.colors.primary)}`,
		},
		rules: {
			'.Label': {
				fontSize: '1rem',
				fontWeight: '600',
				color: '#363636',
				lineHeight: '1',
				paddingBottom: '0.3em',
				marginBottom: '0.2rem',
			},
			'.Input, .AccordionItem, .PickerItem, .PickerItem--selected': {
				boxShadow: 'none',
				borderColor: '#ddd',
			},
			'.Input:focus': {
				boxShadow: `0 0 0 0.125em ${transparentize(0.75, theme.colors.primary)}`,
			},
			'.Input--invalid': {
				boxShadow: 'none',
			},
		},
	};
};

export default useStripeAppearance;
